import react from "react";
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import InfoButton from '../selectComponents/InfoButton';
import DateRange from '../selectComponents/DateRange';
import DateFilter from '../selectComponents/DateFilter';
import HourFilter from '../selectComponents/HourFilter';
import SmrySelect from '../selectComponents/SmrySelect';

const variableChoices = [
  {value: 'temp',  label: 'Temperature'},
  {value: 'dwpt',  label: 'Dewpoint'},
  {value: 'wetb',  label: 'Wet Bulb Temperature'},
  {value: 'wchill', label: 'Wind Chill'},
  {value: 'htindx', label: 'Heat Index'},
  {value: 'pcpn',  label: 'Precipitation'},
  {value: 'wspd',  label: 'Wind Speed'},
  {value: 'wgust', label: 'Wind Gust'},
  {value: 'rhum',  label: 'Relative Humidity'},
  {value: 'pres',  label: 'Station Pressure'},
  {value: 'slp',   label: 'Sea Level Pressure'},
  {value: 'altp',  label: 'Altimeter Setting'},
  {value: 'trange', label: 'Temperature Range'},
  {value: 'srad',   label: 'Solar Radiation'},
]
const smryChoices = [
  {value: 'max', label: 'Highest'},
  {value: 'min', label: 'Lowest'},
]

export default function ExthrlyOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton } = props;

  return (
    <>
      <DateRange 
        userParams={userParams}
        setUserParams={setUserParams}
      />
      <DateFilter
        userParams={userParams}
        setUserParams={setUserParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <HourFilter 
        userParams={userParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <Stack direction="row" sx={{ mt: 2 }} spacing={1}>
        <SmrySelect 
          userParams={userParams}
          setUserParams={setUserParams} 
          selectOptions={selectOptions} 
          handleChange={handleChange} 
          setDisableGoButton={setDisableGoButton} 
          smryChoices={smryChoices} 
          variableChoices={variableChoices} 
        />
        <TextField
          name="numrec"
          placeholder="enter value"
          label="Number of records"
          value={userParams.numrec}
          onChange={handleChange}
          sx={{ width: '15ch' }}
        />
        <TextField
          name="numhrs"
          placeholder="enter value"
          label="Number of hours"
          value={userParams.numhrs}
          sx={{ width: '15ch', "& .MuiSelect-icon": { right: '28px' } }}
          onChange={(e) => handleChange(e,'integer')}
          InputProps={{endAdornment: <InfoButton infoFor="numhrs" />}}
        /> 

      </Stack>
     </>
  )
}
